export default __webpack_public_path__ + "static/damper_w.cc6b8df008f65a272b09d9b6fd711f82.png";